//             /  //          / // /// //    |  // // //           /  //
//            /  ////       /  //    \  //   |  //   \  //        /  ////
//           /  //  //     |  //      \  //  |  //    |  //      /  //  //
//          /  //    //    |  //       | //  |  //   /  //      /  //    //
//         /  /// // ///   |  //       | //  |  // // //       /  /// // ///
//        /  //_______ //  |  //      /  //  |  //  \  //     /  //_______ //
//       /  //       \  //  \  //    /  //   |  //   \  //   /  //       \  //
//       \_//         \__//  \__// // //     |__//    \__//  \_//         \__//
import './App.scss'
import App from './App'
import { Theme } from './misc/Theme'
import { createRoot } from 'react-dom/client'
import { SnackbarProvider } from 'notistack'
import ErrorBoundary from './misc/ErrorBoundary'
import { store, StoreContextComponent } from './stores/Store'
import { ThemeProvider } from '@mui/material/styles'
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom'


export const DisplayDictionary = store.AppStore.DisplayDictionary

export const DisplayValue = store.AppStore.DisplayValue

export const AlertModal = store.AlertStore.AlertModal

export const CloseModal = store.AlertStore.Close

export const Alert = store.AlertStore.Alert

export const version = "1.1.20"

// Use inner and outer roots, this is so that navigation hooks can be called in the inner hook.
function OuterRoot () {
	return (
		<ErrorBoundary>
			<BrowserRouter>
				<StoreContextComponent>
					<InnerRoot />
				</StoreContextComponent>
			</BrowserRouter>
		</ErrorBoundary>
	)
}

function InnerRoot () {
	
	store.AppStore.navigate = useNavigate()
	store.AppStore.location = useLocation()

	return (
		<ThemeProvider theme={Theme}>
			<SnackbarProvider maxSnack={5}>
				<App />
				<store.AlertStore.RenderAlertModals />
			</SnackbarProvider>
		</ThemeProvider>
	)
}

const root = createRoot(document.getElementById('root'));
root.render(<OuterRoot />)